    import React, { useState, useEffect } from "react";
    import { AgGridReact } from 'ag-grid-react';
    import 'ag-grid-community/styles/ag-grid.css';
    import 'ag-grid-community/styles/ag-theme-alpine.css';
    import moment from "moment";
    import $ from "jquery";
    import "daterangepicker/daterangepicker.css";
    import "daterangepicker";
    import axios from 'axios';

    const PlanMasternew = () => {
    const [planData, setPlanData] = useState({
        name: "",
        category: "",
        validity:"31",
        validityType: "",
        numOfMonths: "",
        validityDays: "",
        amount: "",
        discount: "",
        gstPercent: "",
        extrainfo: "",
        tag: "",
        isActive: true,
        offerStartDate: "",
        offerEndDate: "",
    });
    const [alert, setAlert] = useState({ message: "", type: "" });

    const [filteredPlans, setFilteredPlans] = useState([]);
    const [loading, setLoading] = useState(false); // To track loading state
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedPlan, setSelectedPlan] = useState(null);
    

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const handleStatusEdit = (plan) => {
        setSelectedPlan(plan);
        setIsModalOpen(true);
    };
    

    const handleEdit = (plan) => {
        const formattedStartDate = moment(plan.offer_startdate).format("YYYY-MM-DD");
        const formattedEndDate = moment(plan.offer_enddate).format("YYYY-MM-DD");
    
        // Set the plan data
        setPlanData({
            name: plan.name,
            category: plan.category,
            validity: plan.validity,
            validityType: plan.type === "Months" ? "Months" : "Days", // Map the type to 'Monthly' or 'Days'
            numOfMonths: plan.no_of_months,
            validityDays: plan.validity_days,
            amount: plan.entered_amount,
            discount: plan.discount,
            gstPercent: plan.gst_percent,
            extrainfo: plan.extrainfo,
            tag: plan.tag,
            isActive: plan.is_active === 1,
            offerStartDate: formattedStartDate, // Set correctly formatted date
            offerEndDate: formattedEndDate, // Set correctly formatted date
            id: plan.id, // Ensure id is being set
        });
    
        // Calculate the new plan amount based on the selected plan's amount and discount
        calculateNewPlanAmount(plan.entered_amount, plan.discount);

        window.scrollTo({ top: 0, behavior: 'smooth' });

    }; 

    

    const columnDefs = [
        {
            headerName: 'S.No', 
            valueGetter: "node.rowIndex + 1",  // This will calculate serial number starting from 1
            flex: 1, 
            sortable: true, 
            filter: true, 
            minWidth: 100 
        },  {
    headerName: 'Actions',
    flex: 1, sortable: true, filter: true, minWidth: 100,
    cellRenderer: (params) => (
        <div className="flex space-x-1">
        <button
            onClick={() => handleEdit(params.data)}  // Call handleEdit with the plan data
            className="px-1 py-1 text-red-500 rounded"
        >
            Edit
        </button>
        <button
            onClick={() => handleDelete(params.data.id)}
            className="px-3 py-1 text-blue-500 rounded"
        >
            Delete
        </button>
        </div>
    ),
    },
        {
            headerName: 'Status',
            field: 'is_active',
            flex: 1,minWidth: 110,
            valueFormatter: (params) => (params.value === 1 ? 'Active' : 'Inactive'),
            cellRenderer: (params) => (
            <div className="flex items-center space-x-2">
                <span style={{ color: params.value === 1 ? 'green' : 'red', fontWeight: 'bold' }}>
                {params.value === 1 ? 'Active' : 'Inactive'}
                </span>
                <button
                className="text-blue-600 hover:underline"
                onClick={() => handleStatusEdit(params.data)}
                >
                🖉
                </button>
            </div>
            ),
        },
        { headerName: "Plan Name", field: "name", editable: true },
        { headerName: "Category", field: "category", editable: true },
        { headerName: "Validity Type", field: "type", editable: true },
        { headerName: "Validity Days", field: "validity_days", editable: true },
        // { headerName: "Entered Amount", field: "entered_amount", editable: true },
        {
            headerName: "Plan Amount",
            field: "original",
            editable: true,
           
        },
        { headerName: "Discount", field: "discount", editable: true },
        { headerName: "GST %", field: "gst_percent", editable: true },
        {
            headerName: "GST Amount",
            field: "gst_amount",
            editable: false, // It should not be editable since it's calculated
            valueGetter: (params) => {
                const original = params.data.original || 0;
                const gstPercent = params.data.gst_percent || 0;
                const gstAmount = (original * gstPercent) / 100;
                return Math.round(gstAmount); // Round off to the nearest integer
            }
        },
        {
            headerName: "Total Payable Amount",
            field: "total_payable_amount",
            editable: false, // Since it's a calculated field, editing should be disabled
            valueGetter: (params) => {
                const original = params.data.original || 0; // Plan Amount
                const gstAmount = (original * (params.data.gst_percent || 0)) / 100; // GST Amount Calculation
                return Math.round(original + gstAmount); // Round off to the nearest integer
            }
        },
        
 
    

        // {
        //     headerName: "Total Payable Amount",
        //     field: "original",
        //     editable: true,
           
        // },
        
        // {
        //     headerName: 'Offer Start Date',
        //     field: 'offer_startdate',
        //     flex: 1,
        //     minWidth: 130,
        //     valueFormatter: (params) => moment(params.value).format('YYYY-MM-DD'), // Format date to YYYY-MM-DD
        //     editable: true,
        // },
        // {
        //     headerName: 'Offer End Date',
        //     field: 'offer_enddate',
        //     flex: 1,
        //     minWidth: 130,
        //     valueFormatter: (params) => moment(params.value).format('YYYY-MM-DD'), // Format date to YYYY-MM-DD
        //     editable: true,
        // },

        {
            headerName: 'Offer Start Date',
            field: 'offer_startdate',
            flex: 1,
            minWidth: 130,
            valueFormatter: (params) => 
                params.value && moment(params.value).isValid() ? moment(params.value).format('YYYY-MM-DD') : '-',
            editable: true,
        },
        {
            headerName: 'Offer End Date',
            field: 'offer_enddate',
            flex: 1,
            minWidth: 130,
            valueFormatter: (params) => 
                params.value && moment(params.value).isValid() ? moment(params.value).format('YYYY-MM-DD') : '-',
            editable: true,
        },
        
        { headerName: "Tag", field: "tag", editable: true },
        { headerName: "Extra Information", field: "extrainfo", editable: true },
    ];

  
        // { headerName: "Total Payable Amount", field: "original", editable: true },
        // {
        //     headerName: "Total Payable Amount",
        //     field: "",
        //     editable: true,
        //     valueGetter: (params) => {
        //         const enteredAmount = params.data.entered_amount || 0;
        //         const gstAmount = (enteredAmount * (params.data.gst_percent || 0)) / 100;
        //         return enteredAmount + gstAmount;
        //     }
        // }
    

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/plans`);
            
            // Sort the plans so that active plans come first
            const sortedPlans = response.data.sort((a, b) => b.is_active - a.is_active);
    
            setFilteredPlans(sortedPlans); // Update the AG-Grid data with sorted plans
        } catch (error) {
            console.error("Error fetching plan data:", error);
        } finally {
            setLoading(false);
        }
    };
        


    
    const confirmStatusChange = async () => {
        try {
        const updatedStatus = selectedPlan.is_active === 1 ? 0 : 1;
        await axios.put(`${API_BASE_URL}/plans/${selectedPlan.id}/status`, { is_active: updatedStatus });

        // Update status in local state
        setFilteredPlans((prevPlans) =>
            prevPlans.map((plan) =>
            plan.id === selectedPlan.id ? { ...plan, is_active: updatedStatus } : plan
            )
        );

        setIsModalOpen(false); // Close modal after updating the status
        } catch (error) {
        console.error("Error updating status:", error);
        }
    };


    // const handleFormSubmit = async (e) => {
    //     e.preventDefault();
    
    //     const url = planData.id
    //     ? `${API_BASE_URL}/planssup/${planData.id}`  // Use PUT for updating an existing plan
    //     : `${API_BASE_URL}/planss`;  // Use POST for creating a new plan
    
    //     try {
    //     const method = planData.id ? 'put' : 'post';  // Check if it's an update or create operation
    
    //     const response = await axios({
    //         method,
    //         url,
    //         data: {
    //         ...planData,
    //         original: planData.newPlanAmount,  // Include newPlanAmount as original
    //         },
    //     });
    


    //     if (planData.id) {
    //         // If updating, update the plan in the table
    //         setFilteredPlans((prevPlans) =>
    //         prevPlans.map((plan) =>
    //             plan.id === planData.id ? { ...plan, ...planData } : plan
    //         )
    //         );
    //         setAlert({ message: "Plan updated successfully", type: "success" });
    //     } else {
    //         // If creating, add the new plan to the list
    //         setFilteredPlans((prevPlans) => [response.data, ...prevPlans]);
    //         setAlert({ message: "Plan created successfully", type: "success" });
    //     }
    
    //     console.log("Plan saved successfully", response.data);
    //     // window.location.reload();
    
    //     } catch (error) {
    //     console.error("Error saving plan:", error);
    //     setAlert({ message: "Error saving plan. Please try again.", type: "error" });
    //     }
    // };

    // if no discount is provided means entered amount will save as enteredamount and original amount in corresponding fields


    const handleFormSubmit = async (e) => {
        e.preventDefault();
    
        const finalOriginalAmount = planData.newPlanAmount !== null ? planData.newPlanAmount : planData.amount;
    
        const url = planData.id
            ? `${API_BASE_URL}/planssup/${planData.id}`  // Use PUT for updating an existing plan
            : `${API_BASE_URL}/planss`;  // Use POST for creating a new plan
    
        try {
            const method = planData.id ? 'put' : 'post';  // Check if it's an update or create operation
    
            const response = await axios({
                method,
                url,
                data: {
                    ...planData,
                    original: finalOriginalAmount,  // Assign correct value to original field
                },
            });
    
            if (planData.id) {
                // If updating, update the plan in the table
                setFilteredPlans((prevPlans) =>
                    prevPlans.map((plan) =>
                        plan.id === planData.id ? { ...plan, original: finalOriginalAmount } : plan
                    )
                );
                setAlert({ message: "Plan updated successfully", type: "success" });
            } else {
                // If creating, add the new plan to the list
                setFilteredPlans((prevPlans) => [{ ...response.data, original: finalOriginalAmount }, ...prevPlans]);
                setAlert({ message: "Plan created successfully", type: "success" });
            }
    
            console.log("Plan saved successfully", response.data);
                    window.location.reload();

        } catch (error) {
            console.error("Error saving plan:", error);
            setAlert({ message: "Error saving plan. Please try again.", type: "error" });
        }
    };
    

    



    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this plan?")) {
        try {
            await axios.delete(`${API_BASE_URL}/plans/${id}`); // Adjust the URL as needed
            setFilteredPlans((prevPlans) => prevPlans.filter(plan => plan.id !== id)); // Update the state
            console.log("Plan deleted successfully");
        } catch (error) {
            console.error("Error deleting plan:", error);
        }
        }
    };

    
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPlanData((prevState) => ({
        ...prevState,
        [name]: value,
        }));
    };

    const handleRadioChange = (e) => {
        setPlanData((prevState) => ({
        ...prevState,
        isActive: e.target.value === "yes" ? true : false,
        }));
    };


    useEffect(() => {
        if (planData.validityType === "Months" && planData.numOfMonths) {
        const days = planData.numOfMonths * 31; // Assuming each month has 31 days
        setPlanData((prevState) => ({
            ...prevState,
            validityDays: days,
        }));
        } else if (planData.validityType === "Days") {
        setPlanData((prevState) => ({
            ...prevState,
            // validityDays: 31, // Default value for "Days" type is 31
        }));
        }
    }, [planData.numOfMonths, planData.validityType]);
    

    useEffect(() => {
        if (planData.discount > 0) {
            setTimeout(() => {
                $("#offerDateRange").daterangepicker(
                    {
                        startDate: planData.offerStartDate ? moment(planData.offerStartDate) : moment(),
                        endDate: planData.offerEndDate ? moment(planData.offerEndDate) : moment().add(1, "months"),
                        ranges: {
                            "Today": [moment(), moment()],
                            "Tomorrow": [moment().add(1, "days"), moment().add(1, "days")],
                            "Next 7 Days": [moment(), moment().add(7, "days")],
                            "Next 30 Days": [moment(), moment().add(30, "days")],
                        }
                    },
                    handleOfferStartDateChange
                );
            }, 100); // Delay initialization slightly to ensure the field is present in the DOM
        }
    }, [planData.discount]); // Run only when discount changes
    

    const handleOfferStartDateChange = (startDate, endDate) => {
        setPlanData((prevState) => ({
        ...prevState,
        offerStartDate: startDate.format("YYYY-MM-DD"),
        offerEndDate: endDate.format("YYYY-MM-DD"),
        }));
    };

    const handleValidityTypeChange = (e) => {
        const newValidityType = e.target.value;
        setPlanData((prevState) => ({
        ...prevState,
        validityType: newValidityType,
        numOfMonths: newValidityType === "Months" ? 1 : 0,
        validityDays: newValidityType === "Months" ? 31 : prevState.validityDays,
        }));
    };

    const handleAmountChange = (e) => {
        const enteredAmount = e.target.value;
        setPlanData((prevState) => ({
        ...prevState,
        amount: enteredAmount,
        }));
        calculateNewPlanAmount(enteredAmount, planData.discount);
    };

    const handleDiscountChange = (e) => {
        const enteredDiscount = e.target.value;
        setPlanData((prevState) => ({
        ...prevState,
        discount: enteredDiscount,
        }));
        calculateNewPlanAmount(planData.amount, enteredDiscount);
    };

    // const calculateNewPlanAmount = (amount, discount) => {
    //     if (amount && discount) {
    //     const calculatedAmount = amount - (discount / 100) * amount;
    //     setPlanData((prevState) => ({
    //         ...prevState,
    //         newPlanAmount: calculatedAmount,
    //     }));
    //     } else {
    //     setPlanData((prevState) => ({
    //         ...prevState,
    //         newPlanAmount: null,
    //     }));
    //     }
    // };


    const calculateNewPlanAmount = (amount, discount) => {
        if (amount && discount) {
            const calculatedAmount = amount - (discount / 100) * amount;
            setPlanData((prevState) => ({
                ...prevState,
                newPlanAmount: Math.round(calculatedAmount), // Round off before storing
            }));
        } else {
            setPlanData((prevState) => ({
                ...prevState,
                newPlanAmount: null,
            }));
        }
    };
    

    // Fetch data when the component mounts
    useEffect(() => {
        fetchData(); // Call the fetchData function when the component mounts
    }, []);

    useEffect(() => {
        // Initialize the date range picker for offer dates
        $("#offerDateRange").daterangepicker(
        {
            startDate: moment(),
            endDate: moment().add(1, "months"),
            ranges: {
            "Today": [moment(), moment()],
            "Tomorrow": [moment().add(1, "days"), moment().add(1, "days")],
            "Next 7 Days": [moment(), moment().add(7, "days")],
            "Next 30 Days": [moment(), moment().add(30, "days")],
            },
        },
        handleOfferStartDateChange
        );
    }, []);

    return (
        <div className="bg-gray-100 min-h-screen p-6">

        <div className="max-w-7xl mx-auto p-8">
            {alert.message && (
            <div
            className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
                alert.type === "success" ? "bg-green-500" : "bg-red-500"
            }`}
            >
            <span>{alert.message}</span>
            </div>
        )}
        <div className="bg-blue-700 text-white p-5 rounded-t-md text-xl font-semibold">
            Plan Master
        </div>
        <div className="bg-white p-8 rounded-b-md shadow-lg mt-0">
            <form onSubmit={handleFormSubmit}>
            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Plan Name<span className="text-red-500">*</span></label>
                <input
                    type="text"
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Plan Name"
                    required
                    value={planData.name}
                    onChange={handleChange}
                    name="name"
                />
                </div>

                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Select Category<span className="text-red-500">*</span></label>
                <select
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    value={planData.category}
                    onChange={handleChange}
                    required
                    name="category"
                >
                    <option value="">Select Category</option>
                    <option value="ஜோதிடர்">ஜோதிடர்</option>
                    <option value="ஐயர்">ஐயர்</option>
                    <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                    <option value="எண்கணிதம்">எண்கணிதம்</option>
                    <option value="விபூதி தயாரிப்பவர் - Others">விபூதி தயாரிப்பவர் - Others</option>
                    <option value="ஆன்மீக சொற்பொழிவாளர் - Others">ஆன்மீக சொற்பொழிவாளர் - Others</option>
                </select>
                </div>

                
                
                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Plan Validity Day/Month<span className="text-red-500">*</span></label>
                <select
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    value={planData.validityType}
                    onChange={handleValidityTypeChange}
                    name="validityType"
                    required
                >
                    <option value="">Select Plan Validity</option>
                    <option value="Days">Days</option>
                    <option value="Months">Months</option>
                </select>
                </div>

        
    <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">Validity Days<span className="text-red-500">*</span></label>
        <input
        type="number"
        required
        value={planData.validityDays}
        onChange={(e) => setPlanData({ ...planData, validityDays: e.target.value })}
        className="block w-full p-2 border border-gray-300 rounded-md"
        placeholder="Enter Validity Days"
        readOnly={planData.validityType === "Months"}
        onWheel={(e) => e.target.blur()} // Prevent value change on scroll

        />
    </div>


    {planData.validityType !== "Days" && (  <div className="space-y-2">
    <label className="block text-sm font-medium text-gray-700">Validity (in days)</label>
    <input
        type="number"
        value="31"
        onChange={(e) => setPlanData({ ...planData, validity: e.target.value })}
        className="block w-full p-2 border border-gray-300 rounded-md"
        placeholder="Enter Validity"
        readOnly={planData.validityType === "Months"}
        onWheel={(e) => e.target.blur()} // Prevent value change on scroll

    />
    </div>
    )}



                {planData.validityType === "Months" && (
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">No of Months<span className="text-red-500">*</span></label>
                    <input
                    type="number"
                    required
                    value={planData.numOfMonths}
                    onChange={handleChange}
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    name="numOfMonths"
                    onWheel={(e) => e.target.blur()} // Prevent value change on scroll

                    />
                </div>
                )}

                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Enter Amount<span className="text-red-500">*</span></label>
                <input
                    type="number"
                    required
                    value={planData.amount}
                    onChange={handleAmountChange}
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Amount"
                    name="amount"
                    onWheel={(e) => e.target.blur()} // Prevent value change on scroll

                />
                </div>

                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">GST %<span className="text-red-500">*</span></label>
                <input
                    type="number"
                    required
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter GST %"
                    name="gstPercent"
                    value={planData.gstPercent}
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()} // Prevent value change on scroll

                />
                </div>

                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Discount % (For Offer Plans only)</label>
                <input
                    type="number"
                    value={planData.discount}
                    onChange={handleDiscountChange}
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Discount %"
                    name="discount"
                    onWheel={(e) => e.target.blur()} // Prevent value change on scroll

                />
                </div>

    {/* <div className="space-y-2 col-span-2">
        <label className="block text-sm font-medium text-gray-700">New Plan Amount</label>
        <input
        type="number"
        value={planData.newPlanAmount ? planData.newPlanAmount.toFixed(2) : ''}
        className="block w-full p-2 border border-gray-300 rounded-md"
        readOnly
        />
    </div> */}

{/* <div className="space-y-2 col-span-2">
    <label className="block text-sm font-medium text-gray-700">New Plan Amount</label>
    <input
        type="number"
        value={planData.newPlanAmount ? Math.round(planData.newPlanAmount) : ''}
        className="block w-full p-2 border border-gray-300 rounded-md"
        readOnly
    />
</div>

    
                <div className="space-y-2 col-span-2">
                    <label className="block text-sm font-medium text-gray-700">Offer Start and End Date</label>
                    <div
                    id="offerDateRange"
                    className="bg-white border px-4 py-2 inline-block rounded cursor-pointer"
                    >
                    {planData.offerStartDate && planData.offerEndDate ? `${planData.offerStartDate} - ${planData.offerEndDate}` : 'Select Date Range'}
                    </div>
                </div> */}
    

    {/* Conditionally show the New Plan Amount field when a discount is entered */}
{planData.discount > 0 && (
    <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">New Plan Amount</label>
        <input
            type="number"
            value={planData.newPlanAmount ? Math.round(planData.newPlanAmount) : ''}
            className="block w-full p-2 border border-gray-300 rounded-md"
            readOnly
        />
    </div>
)}

{/* Conditionally show Offer Start and End Date field when a discount is entered */}
{planData.discount > 0 && (
    <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">Offer Start and End Date</label>
        <div
            id="offerDateRange"
            className="bg-white border px-4 py-2 inline-block rounded cursor-pointer"
        >
            {planData.offerStartDate && planData.offerEndDate
                ? `${planData.offerStartDate} - ${planData.offerEndDate}`
                : 'Select Date Range'}
        </div>
    </div>
)}


                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Is Active<span className="text-red-500">*</span></label>
                <div className="flex items-center space-x-4">
                    <div>
                    <input
                        type="radio"
                        id="yes"
                        name="isActive"
                        value="yes"
                        required
                        checked={planData.isActive}
                        onChange={handleRadioChange}
                    />
                    <label htmlFor="yes" className="text-sm">Yes</label>
                    </div>
                    <div>
                    <input
                        type="radio"
                        id="no"
                        name="isActive"
                        value="no"
                        checked={!planData.isActive}
                        onChange={handleRadioChange}
                    />
                    <label htmlFor="no" className="text-sm">No</label>
                    </div>
                </div>
                </div>

                <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Extra Information</label>
                <textarea
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter extra information"
                    rows="4"
                    value={planData.extrainfo}
                    onChange={handleChange}
                    name="extrainfo"
                />
                </div>

                <div className="space-y-2 col-span-2">
                <label className="block text-sm font-medium text-gray-700">Tag</label>
                <input
                    type="text"
                    className="block w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Tag"
                    value={planData.tag}
                    onChange={handleChange}
                    name="tag"
                />
                </div>
            </div>

            <div className="mt-4 flex justify-between items-center">
                <span className="text-xs text-blue-500">
                Note *: Only for offer plans, please enter discount %. Otherwise leave blank.
                </span>
                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-md">
                SAVE
                </button>
                
    {/* {alert.message && (
        <div className={`alert ${alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'} text-white p-4 rounded mb-4`}>
        {alert.message}
        </div>
    )} */}
            </div>
            </form>

            {/* Ag-Grid below the form */}
            <div className="ag-theme-alpine mt-4" style={{ height: 400, width: '100%' }}>
            <AgGridReact
                rowData={filteredPlans}
                columnDefs={columnDefs}
                defaultColDef={{ sortable: true, filter: true, editable: true }}
                pagination={true}
            />
            </div>
        </div>
        {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded shadow-lg text-center">
                <p className="text-lg font-semibold mb-4">
                Are you sure you want to change the status of {selectedPlan.name}?
                </p>
                <div className="flex justify-center space-x-4">
                <button
                    className="px-4 py-2 bg-green-500 text-white rounded"
                    onClick={confirmStatusChange}
                >
                    Yes
                </button>
                <button
                    className="px-4 py-2 bg-red-500 text-white rounded"
                    onClick={() => setIsModalOpen(false)}
                >
                    No
                </button>
                </div>
            </div>
            </div>
        )}
        </div>
        </div>
    );
    };

    export default PlanMasternew;
